/**
 * @generated SignedSource<<3836a86fb34c298bdb603832be8f6710>>
 * @relayHash 6851e4d8e00ac68e2be712f97fc883a4
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6851e4d8e00ac68e2be712f97fc883a4

import { ConcreteRequest } from 'relay-runtime';
export type Ch_resendReferralLetterInput = {
  referralLetterId: string;
};
export type useChResendReferralLetterMutation$variables = {
  input: Ch_resendReferralLetterInput;
};
export type useChResendReferralLetterMutation$data = {
  readonly ch_resendReferralLetter: {
    readonly ch_ReferralLetter: {
      readonly id: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly __typename: "CareProviderHinEmailMissing";
    } | {
      readonly __typename: "DocumentDoesNotExist";
    } | {
      readonly __typename: "ReferralLetterNotConcluded";
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    }> | null;
  };
};
export type useChResendReferralLetterMutation = {
  response: useChResendReferralLetterMutation$data;
  variables: useChResendReferralLetterMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_ReferralLetter",
  "kind": "LinkedField",
  "name": "ch_ReferralLetter",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChResendReferralLetterMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_resendReferralLetterPayload",
        "kind": "LinkedField",
        "name": "ch_resendReferralLetter",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": (v3/*:: as any*/),
                "type": "CareProviderHinEmailMissing",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v3/*:: as any*/),
                "type": "ReferralLetterNotConcluded",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v3/*:: as any*/),
                "type": "DocumentDoesNotExist",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChResendReferralLetterMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_resendReferralLetterPayload",
        "kind": "LinkedField",
        "name": "ch_resendReferralLetter",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": (v3/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "6851e4d8e00ac68e2be712f97fc883a4",
    "metadata": {},
    "name": "useChResendReferralLetterMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "74d4ac24c4994be8da40c95913825f38";

export default node;
